import React from 'react';
import {
  BarChart as ReBarChart,
  Bar,
  LineChart as ReLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { ChartCard } from '../../dashboard';

// Shared axis / tooltip config so both chart versions stay identical.
const axisProps = {
  x: {
    dataKey: 'label',
    tick: { fontSize: 9, fill: '#94a3b8' },
    angle: 0,
    textAnchor: 'middle',
    height: 28,
    minTickGap: 2,
  },
  y: {
    allowDecimals: false,
    tick: { fontSize: 11, fill: '#94a3b8' },
  },
};

const tooltipProps = {
  contentStyle: { borderRadius: 8, fontSize: 12, border: '1px solid #e5e7eb' },
  // Axis shows mm-dd; tooltip shows the full yyyy-mm-dd.
  labelFormatter: (label, payload) => payload?.[0]?.payload?.date || label,
};

export default function BarChart({ data = [] }) {
  return (
    <ChartCard
      title="Daily Attendance Trend"
      empty={!data.length}
      emptyText="No attendance records for this period"
      emptyHeight={300}
    >
      <ResponsiveContainer width="100%" height={300}>
          {/* ─────────────── BAR CHART (active) ─────────────── */}
          <ReBarChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
            <XAxis {...axisProps.x} />
            <YAxis {...axisProps.y} />
            <Tooltip {...tooltipProps} cursor={{ fill: '#f8fafc' }} />
            <Bar dataKey="count" name="Records" fill="#10b981" radius={[3, 3, 0, 0]} maxBarSize={22} />
          </ReBarChart>

          {/* ─────────────── LINE CHART (inactive) ─────────────── */}
          {/* <ReLineChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
            <XAxis {...axisProps.x} />
            <YAxis {...axisProps.y} />
            <Tooltip {...tooltipProps} />
            <Line
              type="monotone"
              dataKey="count"
              name="Records"
              stroke="#10b981"
              strokeWidth={2.5}
              dot={{ r: 2.5 }}
              activeDot={{ r: 4 }}
            />
          </ReLineChart> */}

      </ResponsiveContainer>
    </ChartCard>
  );
}